import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';

import DownloadCompanies from './DownloadCompanies.jsx';
import SelectExcelFile from './SelectExcelFile.jsx';
import ReviewEntities from './ReviewEntities.jsx';

import { GETTING_STARTED_LINK } from './../../../../constants';

class BatchUploadInitialStage extends React.Component{

    constructor(props) {
        super(props);
        
        this.goToCreateEntityPage = this.goToCreateEntityPage.bind(this);
    }
    
    goToCreateEntityPage() {
        let currentLocation = this.props.router.location.pathname;
        this.props.router.push('/create-new-entity?previousPath=' + encodeURIComponent(currentLocation));
    }
    
    render() {
        return (
            <div>
                <div className="heading-top">
                    <div className="heading-top__title">
                        <span>Getting Started</span>
                    </div>
                    <div className="heading-top__subtitle">
                        <FormattedMessage id="Entities_CoreFunctionality_UIText_batchUpload.getStarted" />
                    </div>
                </div>

                <div className="super-container">

                    <DownloadCompanies downloadFile={this.props.downloadFile} />
                    <SelectExcelFile stage={this.props.stage}
                                     selectFile={this.props.selectFile}
                                     fileSelected={this.props.fileSelected} />
                    <ReviewEntities />

                </div>

                <div className="route-to-create-new-entity">
                    <div className="route-to-create-new-entity__text">
                        <FormattedMessage id="Entities_CoreFunctionality_UIText_batchUpload.singleEntityQuestion"/>
                    </div>
                    <button type="button"
                            className="button-primary-lg"
                            onClick={this.goToCreateEntityPage}>
                        <FormattedMessage
                            id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.companies.createNewEntity" />
                    </button>
                </div>

                <div className="heading-bottom">
                    <FormattedMessage id="Entities_CoreFunctionality_UIText_batchUpload.getStartedQuestions" />
                    &nbsp;
                    <span>-</span>
                    <a target="_blank" href={this.props.helpUrlRoot + GETTING_STARTED_LINK}>
                        &nbsp;
                        <FormattedMessage
                            id="Entities_CoreFunctionality_UIText_batchUpload.getStartedQuestionsLink" />
                    </a>
                </div>
            </div>
        );
    }

}

export default withRouter(BatchUploadInitialStage);




// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/InitialStage/InitialStage.index.jsx